import ko from 'knockout';
import { ICategoryPathOptions } from './ICategoryPathOptions';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
const Genesis = require("../../Genesis.js");
const style: string = require('./CategoryPathComponent.css');

interface FancytreeNode {
    setExpanded(expanded: boolean): void;
    children?: FancytreeNode[];
}

enum FancytreeSelectionMode {
    single = 1,
    multi = 2,
    mutlti_hier = 3
}

export class CategoryPathComponent {
    private url = '';
    private modalSelector = '';
    private pathSelector = '';
    private selectButtonSelector = '';
    private static readonly classificationHolderSelector: string = '#classificationHolder';
    private static readonly classificationTreeSelector: string = '#classificationTree';
    private static readonly selectCategoryButtonSelector: string = '.selectCategory';
    private static readonly idValueSelector: string = '#CategoryId';
    private txtClassification = document.getElementById("txtClassificationSearch") as HTMLInputElement;
    private btnClear = document.getElementById("btnClear") as HTMLInputElement;


    public categoryId: KnockoutObservable<number | undefined> = ko.observable<number>();
    public categoryIds: KnockoutObservable<Array<number>> = ko.observable<Array<number>>([]);
    private isReadOnly = false;
    private isMainClassification = false;
    private preventParentSelection = false;
    private allowMultiSelect = false;
    private isRequired = true;
    private modal: Modal | null = null;
    private formId: string;
    constructor(options: ICategoryPathOptions) {
        this.url = options.Url;
        this.modalSelector = `${options.ModalId}`;
        this.pathSelector = `#${options.PathId}`;
        this.selectButtonSelector = `#${options.SelectButtonId}`;
        this.isReadOnly = options.IsReadOnly;
        this.isMainClassification = options.IsMainClassification !== undefined ? options.IsMainClassification : true;
        this.preventParentSelection = options.PreventParentSelection;
        this.allowMultiSelect = options.AllowMultiSelect;
        this.configureTree();
        this.bindCategoryButtons();
        this.isRequired = options.IsRequired;
        this.formId = options.FormId;
        const selectorModal = document.getElementById(this.modalSelector);
        if (selectorModal !== null) {
            this.modal = new Modal(selectorModal, { backdrop: 'static', keyboard: false });
        }
        this.collapseCategory();

        this.txtClassification.addEventListener("input", this.filterCategoryTree.bind(this));
        this.btnClear.addEventListener("click", this.clearFilterSearch.bind(this));
    }

    public setup = (options: ICategoryPathOptions) => {
    }

    public reloadCategory = (categoryId: number) => {
        this.loadCategoryPath([categoryId]);

        if (categoryId) {
            const node = $(CategoryPathComponent.classificationTreeSelector).data("uiFancytree").getNodeByKey(categoryId.toString());
            if (node !== null) {
                node.setSelected(true);
            }
        }
    }

    public reloadCategories = (categoryIds: Array<number>) => {
        this.categoryIds(categoryIds);
        this.loadCategoryPath(categoryIds);
    }

    public unselectAll() {
        this.categoryIds([]);
        this.loadCategoryPath(this.categoryIds());
    }

    public deleteCategory = (categoryId: number) => {
        this.categoryIds(this.categoryIds().filter(c => c != categoryId));
        this.loadCategoryPath(this.categoryIds());
    }

    public enable = (enable: boolean) => {
        if (enable) {
            $('.selectCategory').show();
            $(".removeCategory").show();
        }
        else {
            $('.selectCategory').hide();
            $(".removeCategory").hide();
        }
    }

    public getSelectedCategoryText(): string[] {
        const tree = $(CategoryPathComponent.classificationTreeSelector).fancytree("getTree")
        const nodes: Fancytree.FancytreeNode[] = [];
        this.categoryIds().forEach(c => nodes.push(tree.getNodeByKey(c.toString())));
        return nodes.map(n => $(`<span>${n.title}</span>`).text());
    }

    public validateCategorySelected(): void {
        if (!this.isRequired) return;
        const form = document.forms[0];
        const validationCategory = form["validationCategory"];
        if (validationCategory !== null) {
            if (this.categoryIds().length === 0 && $(CategoryPathComponent.idValueSelector).val() === "") {
                validationCategory.value = "";
            }
            else {
                validationCategory.value = "X";
            }
        }
    }

    private configureTree = () => {
        if (!this.allowMultiSelect) {
            $(CategoryPathComponent.classificationTreeSelector).addClass("fancytree-radio");
        }

        // Moved to custom.js - leave here for reference
        //$(CategoryPathComponent.classificationTreeSelector).fancytree(
        //    {
        //        checkbox: true,                    
        //        icons: false,
        //        selectMode: this.allowMultiSelect ? 2 : 1,
        //        activate: () => false                
        //    });

        const tree: Fancytree.Fancytree = $(CategoryPathComponent.classificationTreeSelector).fancytree("getTree");
        let selectionMode: number = this.allowMultiSelect ? FancytreeSelectionMode.multi : FancytreeSelectionMode.single;
        tree.options.selectMode = selectionMode;
        $(CategoryPathComponent.classificationHolderSelector).show("fast");

        if (this.preventParentSelection) {
            $(CategoryPathComponent.classificationHolderSelector + " .fancytree-has-children > .fancytree-checkbox").hide();
        }
    };

    private tickSelectedCategories = () => {
        const tree: Fancytree.Fancytree = $(CategoryPathComponent.classificationTreeSelector).fancytree("getTree");
        tree.getSelectedNodes().forEach(n => n.setSelected(false));
        this.categoryIds().forEach(c => tree.getNodeByKey(c.toString()).setSelected());
    };

    private bindCategoryButtons = () => {
        if (this.isReadOnly) {
            $(CategoryPathComponent.selectCategoryButtonSelector).hide();
            return;
        }

        $(this.pathSelector).on('click', CategoryPathComponent.selectCategoryButtonSelector, () => {
            if (this.modal !== null) {
                this.modal.show()
                this.tickSelectedCategories();
            }
            return false;
        });

        let self = this;
        $(this.selectButtonSelector).click(() => {
            const tree = $(CategoryPathComponent.classificationTreeSelector).fancytree("getTree")
            if (self.allowMultiSelect) {
                const categoryIds = tree.getSelectedNodes().map((n: { key: string }) => parseInt(n.key))
                self.categoryIds(categoryIds)
            }
            else if (!self.allowMultiSelect) {
                const lastSelectedNode = tree.lastSelectedNode;
                if (lastSelectedNode === null) {
                    Swal.fire({ text: "Please select a category" });
                    return;
                }
                $(CategoryPathComponent.idValueSelector).val(lastSelectedNode.key).change();
                self.categoryIds([]);
                self.categoryIds().push(lastSelectedNode.key);
            }
            self.loadCategoryPath(this.categoryIds());
        });
    };

    private loadCategoryPath = (categoryIds: Array<number>) => {
        let data = {};
        if (this.allowMultiSelect) {
            data = { recordId: 0, categoryIds: categoryIds || [0], isRequired: this.isRequired }
        }
        else {
            data = { recordId: 0, categoryId: categoryIds[0], isRequired: this.isRequired }
        }
        $.ajax({
            type: 'POST',
            url: this.url,
            data: data,
            success: response => {
                $(this.pathSelector).html(response);
                const categoryId: string | number | string[] | undefined = $(CategoryPathComponent.idValueSelector).val();
                if (typeof categoryId === "number") {
                    this.categoryId(categoryId);
                }
            },
            error: error => {
                Swal.fire({ text: "Error loading Category details" });
            }
        })
            .done(() => {
                if (this.modal !== null) {
                    this.modal.hide();
                }

                let self = this;
                $(".removeCategory").click((e: any) => {
                    const target = e.target;
                    if (target !== null) {
                        self.deleteCategory($(target).data().categoryid);
                    }
                });
            });
    };

    public expandTopTwoLevels = (node: FancytreeNode, currentLevel: number, maxLevels: number) => {
        if (currentLevel < maxLevels) {
            node.setExpanded(true);
        }
        else {
            node.setExpanded(false);
        }

        if (node.children) {
            for (var i = 0; i < node.children.length; i++) {
                this.expandTopTwoLevels(node.children[i], currentLevel + 1, maxLevels);
            }
        }
    };

    public collapseCategory = () => {
        const categoryPathComponent = this;
        $.get(Genesis.url("/Home/GetCategoryTreeCollapseCount"), function (_categoryTreeCollapseCount) {
            var totalNodeCount = 0;
            $(CategoryPathComponent.classificationTreeSelector).fancytree("getTree").visit(function (node: FancytreeNode) {
                totalNodeCount++;
            });
            const fancytree = $(CategoryPathComponent.classificationTreeSelector).fancytree("getTree");
            fancytree.visit(function (node: FancytreeNode) {
                if (totalNodeCount >= _categoryTreeCollapseCount) {
                    categoryPathComponent.expandTopTwoLevels(node, 0, 1);
                }
            });
        });
    };


    public clearFilterSearch(event: Event) {
        $("#txtClassificationSearch").val("");
        this.filterCategoryTree();
    }

    public filterCategoryTree() {
        const _obj = this;
        $.get(Genesis.url("Home/FilterCategoryTree"), {
            searchText: $("#txtClassificationSearch").val(),
            classificationSystemCode: $("#hdnSystemCode").val(),
            recordTypeId: $("#hdnRecordTypeId").val(),
        }, function (responseResult) {
            $("#classificationSection").html(responseResult);
            let selectionMode: number = FancytreeSelectionMode.mutlti_hier;
            $(CategoryPathComponent.classificationTreeSelector).fancytree(
                {
                    checkbox: true,
                    icons: false,
                    selectMode: selectionMode,
                    activate: () => false
                });
            _obj.configureTree();
        });
    }
}